"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloorAreaFilter = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _rangeSearchQueryField = require("../range-search-query-field");
var _range = require("../range");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class FloorAreaFilter extends _rangeSearchQueryField.RangeSearchQueryField {
  constructor() {
    super(...arguments);
    _defineProperty(this, "urlSlug", FloorAreaFilter.urlSlug);
  }
  get validListingTypes() {
    return _node.AllExceptBusinessListingTypeKeys;
  }
  static fromUrlParameters(searchOptions, q) {
    return new FloorAreaFilter(searchOptions, _range.Range.fromUrlParameter(q[FloorAreaFilter.urlSlug]));
  }
}
exports.FloorAreaFilter = FloorAreaFilter;
_defineProperty(FloorAreaFilter, "urlSlug", 'floorarea');